{{ text }}
<nb-icon *ngIf="removable"
         (click)="_remove()"
         class="nb-tag-remove size-{{size}}"
         icon="close-outline"
         pack="nebular-essentials"
         aria-hidden="true">
</nb-icon>
